// extracted by css-extract-rspack-plugin
export default {"RecaptchaDisclaimer":"sputnik__RecaptchaDisclaimer__qFl_u","recaptchaDisclaimer":"sputnik__RecaptchaDisclaimer__qFl_u"};